export const OLD_CHART = 'old-chart'
export const CHART = 'chart'
export const CHART_TABLE = 'chart-table'
export const CHART_COLOR_LEGEND = 'chart-color-legend'
export const DATASET_FILTER = 'dataset-filter'
export const DATASET_TABLE = 'dataset-table'
export const DATASET_VALUE = 'dataset-value'
export const EMBEDDED_CONTENT = 'embedded-content'
export const IMAGE = 'image'
export const INITIATIVE_CHART = 'initiative-chart'
export const INITIATIVE_TIMELINE = 'initiative-timeline'
export const LINEAR_GAUGE = 'linear-gauge'
export const NOTES = 'notes'
export const PERFORMANCE_BUBBLE = 'performance-bubble'
export const PERSPECTIVE = 'perspective'
export const REPORT = 'report'
export const SPEEDOMETER = 'speedometer'
export const TEXT = 'text'
export const SHAPE = 'shape'

export default {
	OLD_CHART,
	CHART,
	CHART_TABLE,
	CHART_COLOR_LEGEND,
	DATASET_FILTER,
	DATASET_TABLE,
	DATASET_VALUE,
	EMBEDDED_CONTENT,
	IMAGE,
	INITIATIVE_CHART,
	INITIATIVE_TIMELINE,
	LINEAR_GAUGE,
	NOTES,
	PERFORMANCE_BUBBLE,
	PERSPECTIVE,
	REPORT,
	SPEEDOMETER,
	TEXT,
	SHAPE
}
